function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { AllhomesGlobalContextProvider } from './provider';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var withAllhomesProvider = contextFactory => (WrappedComponent, defaultProps) => {
  var hoc = props => ___EmotionJSX(AllhomesGlobalContextProvider, _extends({}, props, {
    contextFactory: contextFactory
  }), ___EmotionJSX(WrappedComponent, _extends({}, defaultProps, props)));
  setHOCDisplayName(hoc, WrappedComponent, 'allhomesContextProvider');
  return hoistNonReactStatics(hoc, WrappedComponent);
};